<template>
  <div>
    <UserStatistics></UserStatistics>
    <v-row dense>
      <v-col cols="12" md="7">
        <TitleCard></TitleCard>
        <v-row dense>
          <v-col cols="12" sm="4" md="4" v-for="item in forecast" :key="item.day">
            <v-card
              outlined
              tile
              :to="item.links"
              :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'"
              class="widgets-card"
            >
              <v-btn
                class="mx-2 mb-3"
                fab
                link
                small
                elevation="0"
                :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F8F6FC'"
              >
                <v-icon color="greenMain">
                  {{ item.icon }}
                </v-icon>
              </v-btn>
              <p class="mb-0">{{ item.day }}</p>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="5">
        <BalanceCardOthers></BalanceCardOthers>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="12" md="12">
        <v-card
          elevation="0"
          tile
          :class="$vuetify.theme.dark ? 'blue-darken-2' : 'white-lighten-2'"
          class="copy-to-clipboard"
        >
          <p class="content d-flex align-center mb-4">
            <v-img
              max-width="14"
              class="mr-2"
              src="@/assets/Dashboard/copy.svg"
            ></v-img>

            Your TradeMaster IB Link
          </p>
          <div class="d-flex align-center justify--md-space-between w-100" v-if="this.ibLink">
            <p class="copy-link trade-master-share-link text-truncate w-100">
              {{ this.ibLink }}
            </p>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span @click="copyCode" @mouseout="reset" style="cursor: pointer" v-bind="attrs" v-on="on">
                  <v-btn
                    tile
                    elevation="0"
                    class="ma-0 ml-2 text-capitalize btn-account"
                    color="teal-lighten-1"
                  >
                    <v-icon class="mr-1" left>mdi-share-variant-outline</v-icon>
                    <b>{{copy}}</b>
                  </v-btn>
                </span>
              </template>
              <span>Copy Your Referral Link</span>
            </v-tooltip>
          </div>
          <v-skeleton-loader v-else type="text" :loading="true" width="600px"></v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>
    <ProfileBar></ProfileBar>
    <v-row dense>
      <v-col cols="12" xl="12">
        <v-card :color="$vuetify.theme.dark ? '#162334' : '#e8f1f8'" elevation="0" class="all-trade-tab rounded-0 mb-0">
          <v-tabs
          
            :background-color="
              $vuetify.theme.dark ? '#162334' : '#e8f1f8'
            "
            class="pa-5"
          >
            <v-tab class="ml-0"> Clients</v-tab>
            <!-- <v-tab> IB Commission </v-tab> -->
            <v-tab> My Transactions </v-tab>
            <v-tab-item>
              <v-card flat class="mb-0">
                <ClientsTab></ClientsTab>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <IbCommissionInTab></IbCommissionInTab>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <MyTransactionsTab></MyTransactionsTab>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BalanceCardOthers from "@/components/TradeMaster/BalanceCardOthers.vue";
import ClientsTab from "@/components/TradeMaster/ClientsTab.vue";
import IbCommissionInTab from "@/components/TradeMaster/IbCommissionInTab.vue";
import MyTransactionsTab from "@/components/TradeMaster/MyTransactionsTab.vue";
import ProfileBar from "@/components/TradeMaster/ProfileBar.vue";
import TitleCard from "@/components/TradeMaster/TitleCard.vue";
import UserStatistics from "@/components/TradeMaster/UserStatistics.vue";
import toast from "@/services/Notification";
import { mapState, mapActions } from "vuex";
import { TRADEMASTER__ACTIONS } from "@/store/action-types";

export default {
  data: () => ({
    forecast: [
      {
        day: "withdraw",
        icon: "mdi-tray-arrow-up",
        links: "/bank-transfer",
      },
      {
        day: "Transfer",
        icon: "mdi-swap-horizontal",
        links: "/transfer-form",
      },
      {
        day: "Clients & Level",
        icon: "mdi-account-multiple",
        links: "/clients-level",
      },
    ],
    copyText: "Copy",
    copy:"Copy",
  }),
  components: {
    UserStatistics,
    BalanceCardOthers,
    TitleCard,
    ProfileBar,
    MyTransactionsTab,
    IbCommissionInTab,
    ClientsTab,
  },
  computed: {
    ...mapState("tradeMaster", ["accountDetails"]),

    ibLink() {
      return this.accountDetails.investor_referral_link
    }
  },

    methods: {
    ...mapActions("tradeMaster", [TRADEMASTER__ACTIONS.MT5ACCOUNTDETAILS]),

    async copyCode() {
      if (!this.accountDetails.investor_referral_link) {
        this.copyText = "Unable to copy";
        this.$toast?.info("You do not have any IB code to copy"); 
      } else {
        await navigator.clipboard.writeText(this.accountDetails.investor_referral_link);
        this.copy = "Copied";
        this.reset;
      }
    },

    reset() {
      this.copy = "Copy";
    },
  },

  
  async mounted() {
    await this[TRADEMASTER__ACTIONS.MT5ACCOUNTDETAILS](this.$route.params.id);
  },
};
</script>
